module.exports = __webpack_public_path__ + "media/images/brand/app_symbol_400-f4851766e2e4b8a01ddbfea96243f00d.png";